<script setup>
import { reactive, toRefs, onMounted, watch, ref } from 'vue';
import { getEbookLists } from '@/api/index.js';
import useGoDetail from '@/minixs/goDetail.js';
const state = reactive({
    rankLists: []
});
/** 详情页的跳转 使用 mixin 的跳转方法**/
const { handleDetail } = useGoDetail();

const {
    rankLists
} = toRefs(state);

onMounted(() => {
    // 排行
    getEbookLists({
        sortType: 1
    }).then(({ data }) => {
        state.rankLists = data?.list.map(item => ({
            ...item,
            titleText: item.title.replace(/《|》/g, '')
        })) || [];

    });
});
</script>

<template>
    <div class="books-rank flex">
        <!--   前三名         -->
        <div class="books-prev flex">
            <div v-for="(item, index) in rankLists"
                 v-show="index < 3"
                 :key="item.id"
                 @click="handleDetail(item)"
                 :class="['books-prev-item','style'+(index+1)]">
                <i>{{index+1}}</i>
                <p class="line1">{{item.titleText}}</p>
            </div>
        </div>
        <!--   剩余排名         -->
        <div class="books-name">
            <p v-for="(item, index) in rankLists"
               v-show="index >= 3 && index < 11"
               @click="handleDetail(item)"
               :key="item.id"
               class="line-clamp1">
                <i>{{index+1}}</i> {{item.titleText}}
            </p>
        </div>
        
    </div>

</template>

<style scoped lang="scss">
.books-rank{
    width: 100%;
    height: 591px;
    overflow: hidden;
    align-items: center;

    .books-prev{
        gap: 4px;
        //margin-top: 89px;
        margin-left: 145px;
        margin-right: 79px;
        &-item{
            width: 117px;
            height: 447px;
            background: #dfc8c5;
            border: 1px solid #ffffff;
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
            text-align: center;
            padding: 17px;
            box-sizing: border-box;
            cursor: pointer;

            i{
                width: 39px;
                height: 39px;
                display: block;
                border-radius: 50%;
                border: 1px solid #af4f3f;
                text-align: center;
                line-height: 39px;
                font-style: normal;
                margin:0 auto 47px;
                font-size:28px;
            }
            p{
                width: 24px;
                height: 300px;
                line-height: 40px;
                // 实现文字垂直排列
                writing-mode: vertical-rl;
                // 超出部分隐藏并显示省略号
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // 设置行高确保文字居中
                line-height: 24px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #474747;
                font-size: 24px;
                margin: auto;
                text-align: left;
            }
        }

        .style1{
            i{
                color: #af4f3f;
                border-color: #af4f3f !important;
            }
        }
        .style2{
            background: #e6d7c8 !important;
            i{
                color: #c16723 !important;
                border-color: #c16723 !important;
            }
        }
        .style3{
            background: #e1ddd3 !important;
            i{
                color:#c16723 !important;
                border-color:#c16723 !important;
            }
        }
    }

    .books-name{
        p{
            padding: 15px 0;
            cursor: pointer;
            i{
                font-style: normal;
            }
        }
    }
}
</style>
